export default __webpack_public_path__ + "static/media/isoftbet.68d0538a.svg";